import { render, staticRenderFns } from "./relative_time.vue?vue&type=template&id=e4ff19e2&"
import script from "./relative_time.vue?vue&type=script&lang=js&"
export * from "./relative_time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports